import { faShieldUser } from '@fortawesome/pro-solid-svg-icons'

import { Banner, BannerVariants, Button, Image, Text } from '@/ui'
import { TypographyStyles, TextColors, mtc } from '@/styles'
import { AI_ASSISTANT_ICON_URL } from './booksQuestion.constants'
import { ONBOARDING_SCREEN } from '../shared/onboardingScreen.styles'

/**
 * Transaction review always routes here, so a member with nothing to answer lands on this
 * screen rather than skipping it. It gets the flow's own chrome for that reason.
 */
export const NothingToSort = ({
  onContinue,
  sortedCount = 0,
  completionFailed = false,
  isCompleting = false,
}: {
  onContinue?: () => void
  sortedCount?: number
  completionFailed?: boolean
  isCompleting?: boolean
}) => (
  <div className={ONBOARDING_SCREEN.page}>
    <div
      className={mtc(
        ONBOARDING_SCREEN.content,
        'flex-1 justify-center text-center'
      )}
    >
      <div className="flex h-20 w-20">
        <Image
          src={AI_ASSISTANT_ICON_URL}
          alt=""
          objectFit="contain"
          className="h-full w-full"
        />
      </div>
      <div
        className={mtc(
          ONBOARDING_SCREEN.header,
          ONBOARDING_SCREEN.narrowColumn
        )}
      >
        <Text variant={TypographyStyles.DISPLAY_SM} textAlign="center">
          Nothing to sort
        </Text>
        <Text
          variant={TypographyStyles.BODY_SM}
          color={TextColors.MUTED}
          textAlign="center"
          className="text-center"
        >
          {sortedCount > 0
            ? 'We sorted every transaction without needing to ask you anything.'
            : 'There are no transactions to sort yet.'}
          <br />
          <br />
          Next, your dashboard will show where you are in the catchup
          bookkeeping process. We&apos;ll flag anything we need from you right
          there.
        </Text>
      </div>
      <div className="flex flex-col items-center gap-2">
        <Button variant="primary" onClick={onContinue} disabled={isCompleting}>
          {isCompleting ? 'Finishing up…' : 'Go to Dashboard'}
        </Button>
        {completionFailed && (
          <Text
            variant={TypographyStyles.BODY_SM}
            color={TextColors.DANGER}
            textAlign="center"
            role="alert"
          >
            We couldn&apos;t finish setting up your account. Try again.
          </Text>
        )}
      </div>
      <Banner
        variant={BannerVariants.DEFAULT}
        icon={faShieldUser}
        wrapperClassName={mtc(
          ONBOARDING_SCREEN.narrowColumn,
          'w-full justify-start'
        )}
      >
        Our bookkeepers will review everything to double-check accuracy.
      </Banner>
    </div>
  </div>
)
